/**
 * This script handles the toggle functionality for elements with
 * the `c-toc-show-hide` and `c-jump-to show-hide` classes
 *
 * Functionalities implemented:
 * - Toggles the visibility of `.c-jump-to.show-hide` elements on clicking
 *   `.c-toc-show-hide` buttons, with smooth slide animations.
 * - Updates the button's class to reflect the current visibility state
 *   (`is-visible` or `is-hidden`).
 *
 * Usage:
 * Include this script on a page where you have elements with the
 * `c-toc-show-hide` class as a button and a corresponding
 * `.c-jump-to.show-hide` as the toggled content.
 *
 * Requires:
 * - jQuery
 *
 */
( function( $ ) {
    $(function() {
        $('.c-toc-show-hide').click(function (e) {
            e.preventDefault();

            const toggleButton = $(this);
            const jumpToElement = $('.c-jump-to.show-hide');

            if (jumpToElement.is(':visible')) {
                jumpToElement.slideUp();
                toggleButton.removeClass('is-visible').addClass('is-hidden');
                return;
            }

            jumpToElement.slideDown();
            toggleButton.removeClass('is-hidden').addClass('is-visible');
        })
    })
})(jQuery)
